/*eslint-disable*/
import React from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";
import { MdLocalShipping } from "react-icons/md";
import { RiMapPinUserFill } from "react-icons/ri";
import SweetAlert from "react-bootstrap-sweetalert";

import BanglesHeader from "views/BanglesPage/Section/BanglesHeader";
import HeaderLink from "views/BanglesPage/Section/BanglesHeaderLink";
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import basicsCheck from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

import { Redirect } from "react-router-dom";

const useStyles = makeStyles(profilePageStyle);
const useStyle = makeStyles(basicsCheck);
const useStyleAlert = makeStyles(style);
const useStyl = makeStyles(aboutUsStyle);

export default function Address({ ...rest }) {
    const [companyName, setCompanyName] = React.useState("");
    const [gstNumber, setGstNumber] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [address1, setAddress1] = React.useState("");
    const [address2, setAddress2] = React.useState("");
    const [address3, setAddress3] = React.useState("");
    const [zipcode, setZipcode] = React.useState("");
    const [city, setCity] = React.useState("");
    const [state, setState] = React.useState("");
    const [shipaddress, setShipaddress] = React.useState("");
    const [shipaddress1, setShipaddress1] = React.useState("");
    const [shipaddress2, setShipaddress2] = React.useState("");
    const [shipaddress3, setShipaddress3] = React.useState("");
    const [shipzipcode, setShipzipcode] = React.useState("");
    const [shipcity, setShipcity] = React.useState("");
    const [shipstate, setShipstate] = React.useState("");
    const [shipcompany, setShipCompany] = React.useState("");
    const [checkBox, setCheckBox] = React.useState(false);
    const [submitted, setSubmitted] = React.useState(false);
    const [alertMsg, alertMsgOps] = React.useState("");
    const [alertType, alertTypeOps] = React.useState("");
    // React.useEffect(() => {
    //     window.scrollTo(0, 0);
    //     document.body.scrollTop = 0;
    // });
    const classes = useStyles();
    const classe = useStyle();
    const classeAlert = useStyleAlert();
    const classeTitel = useStyl();

    const activeSession = sessionStorage.getItem("sessionData");
    const userObj = JSON.parse(sessionStorage.getItem("sessionData"));
    // const headApi = `https://api.bangles.org.in/api/rest`;

    React.useEffect(() => {
        axios.get(headApi + `/user/${userObj && userObj.mobile}`)
            .then((res) => {
                setCompanyName(res.data.company);
                setAddress(res.data.address);
                setAddress1(res.data.address1);
                setAddress2(res.data.address2);
                setAddress3(res.data.address3);
                setZipcode(res.data.zipcode);
                setCity(res.data.city);
                setState(res.data.state);
                setShipaddress(res.data.shipaddress);
                setShipaddress1(res.data.shipaddress1);
                setShipaddress2(res.data.shipaddress2);
                setShipaddress3(res.data.shipaddress3);
                setShipzipcode(res.data.shipzipcode);
                setShipcity(res.data.shipcity);
                setShipstate(res.data.shipstate);
                setGstNumber(res.data.gstno);
                setShipCompany(res.data.company);
            })
    }, []);

    const handleCheckBox = (e) => {
        if (e.target?.checked) {
            setShipCompany(companyName);
            setShipaddress(address);
            setShipaddress1(address1);
            setShipaddress2(address2);
            setShipaddress3(address3);
            setShipzipcode(zipcode);
            setShipcity(city);
            setShipstate(state);
            setCheckBox(false);
        } else {
            setShipCompany("");
            setShipaddress("");
            setShipaddress1("");
            setShipaddress2("");
            setShipaddress3("");
            setShipzipcode("");
            setShipcity("");
            setShipstate("");
            setCheckBox("");
        }
        setCheckBox(e.target.checked);
    }

    const Submit = () => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                mobile: userObj.mobile,
                company: companyName,
                gstno: gstNumber,
                address: address,
                address1: address1,
                address2: address2,
                address3: address3,
                zipcode: zipcode,
                city: city,
                state: state,
                shipaddress: shipaddress,
                shipaddress1: shipaddress1,
                shipaddress2: shipaddress2,
                shipaddress3: shipaddress3,
                shipzipcode: shipzipcode,
                shipcity: shipcity,
                shipstate: shipstate,
            }),
        };

        fetch(
            headApi + "/user/addaddress",
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if (data.message === "Address Added Successfully") {
                    setSubmitted(true);
                    alertTypeOps("success");
                    alertMsgOps("Updated Successfully");
                }
            });
    }

    const hideAlert = () => {
        setSubmitted(false);
        window.location.reload(false);
    };

    return (
        <div>
            {activeSession ? <>
                <Helmet>
                    <title>Address</title>
                </Helmet>
                <BanglesHeader
                    color="info"
                    brand="Home"
                    links={<HeaderLink dropdownHoverColor="info" />}
                    fixed
                    // changeColorOnScroll={{
                    //     height: 200,
                    //     color: "info",
                    // }}
                    {...rest}
                />
                <Parallax
                    image={require("assets/img/examples/city.jpg").default}
                    filter="dark"
                    className={classes.parallax}
                >
                    <div className={classeTitel.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={8}
                                sm={8}
                                className={classNames(
                                    classeTitel.mlAuto,
                                    classeTitel.mrAuto,
                                    classeTitel.textCenter
                                )}
                            >
                                <h1 className={classeTitel.title}>ADDRESS</h1>
                                <h4>

                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        {submitted ? (
                            <SweetAlert
                                type={alertType}
                                style={{ display: "block", marginTop: "100px" }}
                                title={alertMsg}
                                onConfirm={() => hideAlert()}
                                confirmBtnCssClass={
                                    classeAlert.button + " " + classeAlert.success
                                }
                            />
                        ) : null}
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <div className={classes.profile}>
                                    <h3 className={classes.title}><RiMapPinUserFill color="#00acc1" size={35} />Billing Address</h3>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Company Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Company Name...",
                                        onChange: (e) => setCompanyName(e.target.value),
                                        name: "companyName",
                                        value: companyName,
                                    }}
                                    id="companyName"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="GST Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "GST Number...",
                                        onChange: (e) => setGstNumber(e.target.value),
                                        name: "gstNumber",
                                        value: gstNumber,
                                    }}
                                    id="gstNumber"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Address"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Address...",
                                        onChange: (e) => setAddress(e.target.value),
                                        name: "address",
                                        value: address,
                                    }}
                                    id="address"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Address 1"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Address 1...",
                                        onChange: (e) => setAddress1(e.target.value),
                                        name: "address1",
                                        value: address1,
                                    }}
                                    id="address1"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Address 2"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Address 2...",
                                        onChange: (e) => setAddress2(e.target.value),
                                        name: "address2",
                                        value: address2,
                                    }}
                                    id="address2"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Address 3"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Address 3...",
                                        onChange: (e) => setAddress3(e.target.value),
                                        name: "address3",
                                        value: address3,
                                    }}
                                    id="address3"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Zip Code"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Zip Code...",
                                        onChange: (e) => setZipcode(e.target.value),
                                        name: "zipcode",
                                        value: zipcode,
                                    }}
                                    id="zipCode"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="City"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "City...",
                                        onChange: (e) => setCity(e.target.value),
                                        name: "city",
                                        value: city,
                                    }}
                                    id="city"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="State"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "State...",
                                        onChange: (e) => setState(e.target.value),
                                        name: "state",
                                        value: state,
                                    }}
                                    id="state"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>

                            </GridItem>
                        </GridContainer>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <div className={classes.profile}>
                                    <h3 className={classes.title}><MdLocalShipping color="#00acc1" size={35} /> Shipping Address</h3>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={10}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkBox || false}
                                            onChange={(e) => handleCheckBox(e)}
                                            tabIndex={-1}
                                            //   onClick={() => handleToggle(21)}
                                            checkedIcon={<Check className={classe.checkedIcon} />}
                                            icon={<Check className={classe.uncheckedIcon} />}
                                            classes={{
                                                checked: classe.checked,
                                                root: classe.checkRoot,
                                            }}
                                        />
                                    }
                                    classes={{ label: classe.label, root: classe.labelRoot }}
                                    label="Same as Address"
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Company Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Company Name...",
                                        onChange: (e) => setShipCompany(e.target.value),
                                        name: "shipCompany",
                                        value: shipcompany,
                                    }}
                                    id="companyName"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address...",
                                        onChange: (e) => setShipaddress(e.target.value),
                                        name: "shipaddress",
                                        value: shipaddress,
                                    }}
                                    id="shipAddress"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 1"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 1...",
                                        onChange: (e) => setShipaddress1(e.target.value),
                                        name: "shipaddress1",
                                        value: shipaddress1,
                                    }}
                                    id="shipAddress1"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 2"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 2...",
                                        onChange: (e) => setShipaddress2(e.target.value),
                                        name: "shipaddress2",
                                        value: shipaddress2,
                                    }}
                                    id="shipAddress2"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 3"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 3...",
                                        onChange: (e) => setShipaddress3(e.target.value),
                                        name: "shipaddress3",
                                        value: shipaddress3,
                                    }}
                                    id="shipAddress3"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Zip Code"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Zip Code...",
                                        onChange: (e) => setShipzipcode(e.target.value),
                                        name: "shipzipcode",
                                        value: shipzipcode,
                                    }}
                                    id="shipZipCode"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping City"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping City...",
                                        onChange: (e) => setShipcity(e.target.value),
                                        name: "shipcity",
                                        value: shipcity,
                                    }}
                                    id="shipCity"
                                //   required={true}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping State"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping State...",
                                        onChange: (e) => setShipstate(e.target.value),
                                        name: "shipstate",
                                        value: shipstate,
                                    }}
                                    id="shipState"
                                //   required={true}
                                />
                            </GridItem>
                        </GridContainer>
                        <br />
                        <GridContainer justify="center">
                            <Button color="info" onClick={Submit}>Save</Button>
                        </GridContainer>
                        <br />
                    </div>
                </div>
                <BanglesFooter />
            </> : <Redirect to="/" />}
        </div>
    );
}
